import { all, call, put, select, takeLeading } from 'redux-saga/effects';
import { formControlActions } from './formControlSlice';
import { notificationHandler } from 'utils/utils';

import { selectFormById } from './formControlSelectors';

export function* submitForm({ payload: { transactionId, locationId, tabId, populateEmptyFieldsWithSlashes } }) {
    let form = yield select(selectFormById(transactionId));

    const errors = form?.form?.errors;

    let firstInvalidField;
    for (let fieldName of Object.keys(errors)) {
        if (errors[fieldName]) {
            yield put(
                formControlActions.setFieldTouched({
                    formId: transactionId,
                    fieldName,
                })
            );

            if (firstInvalidField) continue;
            firstInvalidField = fieldName;
        }
    }

    if (firstInvalidField) {
        yield put(formControlActions.submitFormFailed());
        yield call(notificationHandler, {
            title: 'Fill all required fields!',
            variant: 'warning',
        });

        const element = document.querySelector(`[name="${firstInvalidField}"]`);
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
        });
        element.select();
        return;
    }
}

export function* onSubmitFormStart() {
    yield takeLeading(formControlActions.submitFormStart.type, submitForm);
}

export function* formControlSaga() {
    yield all([call(onSubmitFormStart)]);
}
